<template lang="pug">
  sweet-modal.payment-modal(
    ref="modal"
    :title="title"
    width="450"
  )
    .payment-modal__container
      ValidationObserver(v-slot="{ invalid }" ref="form")
        .form-group
          .form-row
            ValidationProvider(
              name="amount"
              rules="required|numeric|positive"
              v-slot="{ errors }"
            )
              input.payment-modal__input(
                type="text"
                v-model="amount"
                placeholder="Введите сумму"
                v-bind:class="{ error: errors[0] }"
                :disabled="amountLocked"
              )
              span.payment-modal__error.form-error {{ errors[0] }}
        button.btn.payment-modal__button(
          v-promise-btn
          @click="pay"
          :disabled="invalid"
          ) Оплатить
</template>

<script>
import apiClient from '@/apiClient';

import { mapState } from 'vuex';
import { extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';

// Validation rules
extend('requred', {
  ...required,
  message: 'Укажите сумму'
});

extend('numeric', {
  ...numeric,
  message: 'Введите сумму'
});

extend('positive', {
  validate(value) {
    return value > 0;
  },
  message: 'Сумма должна быть больше нуля'
});

export default {
  name: 'PaymentModal',

  props: {
    fixedAmount: {
      required: false,
      type: Number,
      default: 0
    },

    amountLocked: {
      required: false,
      type: Boolean,
      default: false
    },

    title: {
      required: false,
      type: String,
      default: 'Пополнить баланс'
    }
  },

  data() {
    return {
      amount: ''
    };
  },

  computed: {
    ...mapState({
      firmId: state => state.user.profile.id
    })
  },

  methods: {
    open() {
      this.$refs.modal.open();
      this.amount = this.fixedAmount > 0 ? this.fixedAmount : '';
    },

    pay() {
      return new Promise((resolve, reject) => {
        apiClient
          .post(`/firms/${this.firmId}/billings/payment`, {
            amount: this.amount
          })
          .then(response => {
            window.open(response.data[0].url, '_self');
            resolve(response);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
</script>

<style lang="scss">
.payment-modal {
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__input {
    width: 300px !important;
  }

  &__error {
    text-align: left;
    display: block;
  }

  &__button {
    display: block !important;
    margin: 0 auto !important;
  }
}
</style>
